import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b46aef06")

_pushScopeId("data-v-b46aef06")
const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_3 = { class: "page-footer font-small fixed-bottom" }
const _hoisted_4 = {
  key: 0,
  class: "footer-copyright center text-white bg-warning"
}
const _hoisted_5 = { class: "footer-copyright text-right py-1 text-white container" }
const _hoisted_6 = /*#__PURE__*/_createVNode("a", {
  class: "text-white",
  href: "https://satstreet.com/services/risk-statements",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Risk Statements | ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  class: "text-white",
  href: "https://satstreet.com/services/privacypolicy",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Privacy Policy | ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("a", {
  class: "text-white",
  href: "https://satstreet.com/services/legal-disclosures",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Legal Disclosures | ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.visibleBottom)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          id: "network-status-bar",
          class: ["page-footer font-small fixed-bottom mb-3", { 'bg-success': _ctx.isOnline, 'bg-danger': !_ctx.isOnline }]
        }, [
          _createVNode("h5", null, [
            _createTextVNode(_toDisplayString(_ctx.message) + " ", 1),
            _hoisted_2
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode("footer", _hoisted_3, [
      (!['prod', 'Production', 'PROD'].includes(_ctx.environment))
        ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.environment), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " Satstreet ", 1)
      ])
    ])
  ], 64))
})